module.exports = __webpack_public_path__ + "img/icon_rotate.bcd13d13.png";